import { render, staticRenderFns } from "./TreePropInput.vue?vue&type=template&id=15d4fc2d&"
import script from "./TreePropInput.vue?vue&type=script&lang=ts&"
export * from "./TreePropInput.vue?vue&type=script&lang=ts&"
import style0 from "./TreePropInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports